var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 182,
    viewBox: "0 0 238 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_53",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238,
    height: 182
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.585 0.847076H0.414917V181.153H237.585V0.847076Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.036 113.516H113.344V138.097L89.1094 113.862H22.8505C19.7441 113.862 17.2258 111.344 17.2258 108.238V31.0291C17.2258 27.9227 19.7441 25.4044 22.8505 25.4044H212.734C215.841 25.4044 218.359 27.9227 218.359 31.0291V107.698C218.359 110.804 215.841 113.323 212.734 113.323H199.907",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.028 74.681V88.6722C185.028 91.002 183.823 93.1662 181.843 94.3937L172.628 100.107C170.41 101.481 167.598 101.451 165.411 100.029L156.472 94.2168C154.562 92.975 153.409 90.8513 153.409 88.573V74.6682C153.409 71.8938 155.105 69.4073 157.689 68.3961C162.565 66.4875 171.122 64.5116 180.79 68.4215C183.344 69.4541 185.028 71.9267 185.028 74.681Z",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.08 76.9575C145.629 74.9614 140.744 71.6211 140.744 67.8375C140.744 61.7247 153.493 56.7693 169.219 56.7693C184.944 56.7693 197.693 61.7247 197.693 67.8375C197.693 71.5037 193.107 74.7535 186.044 76.7677",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.409 58.0645L160.681 45H177.423L185.028 58.6308",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.434 97.3226L156.465 104.155C155.682 105.502 154.501 106.574 153.085 107.224L131.634 117.055C129.034 118.247 127.331 120.806 127.237 123.665L126.359 150.157",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.001 97.3226L181.97 104.155C182.752 105.502 183.933 106.574 185.35 107.224L206.801 117.055C209.401 118.247 211.104 120.806 211.198 123.665L212.076 150.157",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.294 162.32V137.672C148.294 137.242 147.911 136.916 147.488 136.991C144.708 137.482 135.601 139.999 133.982 152.035C133.893 152.7 133.611 153.325 133.143 153.806L126.95 160.172C126.563 160.569 126.075 160.853 125.539 160.993L123.144 161.618C122.021 161.911 121.163 162.818 120.933 163.956L119.779 169.659C119.045 173.287 121.818 176.677 125.52 176.677H134.714C135.557 176.677 136.363 176.327 136.938 175.71L147.479 164.391C148.003 163.829 148.294 163.089 148.294 162.32Z",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.142 162.32V137.672C190.142 137.242 190.524 136.916 190.948 136.991C193.728 137.482 202.835 139.999 204.453 152.035C204.543 152.7 204.825 153.325 205.293 153.806L211.486 160.172C211.873 160.569 212.361 160.853 212.897 160.993L215.292 161.618C216.415 161.911 217.273 162.818 217.503 163.956L218.657 169.659C219.391 173.287 216.618 176.677 212.916 176.677H203.722C202.879 176.677 202.073 176.327 201.498 175.71L190.957 164.391C190.433 163.829 190.142 163.089 190.142 162.32Z",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.714 176.677H204.458",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.556 138.721V128.482C142.556 127.272 143.537 126.29 144.748 126.29H193.469C194.679 126.29 195.661 127.272 195.661 128.482V138.097",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.294 163.452H190.142",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.996 105.966L168.995 126.29L183.439 105.966",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.903 145.738C177.566 141.668 173.729 138.721 169.218 138.721C164.708 138.721 160.871 141.668 159.534 145.738",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.913 148.417C164.691 146.239 166.776 144.675 169.218 144.675C171.661 144.675 173.746 146.239 174.524 148.417",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6334 41.968C87.1862 41.6894 86.6202 41.6894 86.1729 41.968C83.9889 43.3286 82.566 45.5446 82.566 48.0489C82.566 50.553 83.9889 52.7692 86.1729 54.1299C86.6202 54.4082 87.1862 54.4082 87.6334 54.1299C89.8177 52.7692 91.2403 50.553 91.2403 48.0489C91.2403 45.5446 89.8177 43.3286 87.6334 41.968Z",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.347 56.275C108.403 55.5316 108.032 54.8224 107.389 54.4444C104.251 52.5986 100.541 52.2681 97.4013 53.9104C94.2619 55.5526 92.4168 58.7892 92.1437 62.4195C92.0877 63.1626 92.4589 63.8721 93.1013 64.2501C96.2393 66.096 99.9501 66.4265 103.089 64.7842C106.229 63.1422 108.074 59.9053 108.347 56.275Z",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1568 65.5583L99.1197 60.0089",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4595 62.4861C65.4035 61.7427 65.7747 61.0332 66.417 60.6555C69.5551 58.8096 73.2659 58.4791 76.405 60.1214C79.5444 61.7637 81.3895 65 81.6626 68.6306C81.7189 69.3737 81.3474 70.0832 80.705 70.4612C77.567 72.307 73.8565 72.6375 70.7171 70.9952C67.5777 69.3529 65.7326 66.1164 65.4595 62.4861Z",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6495 71.7693L74.6866 66.22",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9032 54.7879V91.0915",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.217 91.3645H101.991",
    stroke: "#E8BA3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 43.3871H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 52.8494H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 62.3116H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 71.7739H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 81.2361H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 90.6984H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193 100.161H53.2258",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.026 36.3H205.364C206.595 36.3 207.594 37.2984 207.594 38.5299V45.3371",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.026 101.203H205.364C206.595 101.203 207.594 100.205 207.594 98.9733V92.1661",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.756 36.3H133.419C132.187 36.3 131.189 37.2984 131.189 38.5299V45.3371",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.756 101.203H133.419C132.187 101.203 131.189 100.205 131.189 98.9733V92.1661",
    stroke: "#193C34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.53146db985b2d90436988b0a6e4de318.svg";
export { ForwardRef as ReactComponent };